import React, { useEffect } from 'react'
import { useState } from 'react'
import styles from './styles.module.css'
import { FaPlus } from 'react-icons/fa6';
import { FiMinus } from 'react-icons/fi';
import {Select, InputNumber, Switch, Checkbox, Divider, Spin, Input} from 'antd' 
import { BreathAPIs } from '../../APIs/BreathAPIs';
import { useSelector } from 'react-redux';




const MakeRefund = ({bookingId, selUser, bookingStatus, estimateAmount, unUtilizedFee, billingDataProp, setBookingToView, isRefunded, refundAmounts, isNightCharging, nightChargeEstimate}) => {

    const adminUser = useSelector((state)=>state.auth.user)

    const CheckboxGroup = Checkbox.Group;
    console.log('MakeRefund Component', bookingId, bookingStatus,unUtilizedFee, billingDataProp,refundAmounts);
    const [expanded, setExpanded] = useState(false);
    const [billingData, setBillingData] = useState(billingDataProp);
    const [totalCost, setTotalCost] = useState(billingDataProp?.totalCost)
    const [taxCost, setTaxCost] = useState(billingDataProp?.taxCost ? billingDataProp?.taxCost : 0);
    const [refundValue, setRefundvalue] = useState([]);
    const [refundKeys, setRefundKeys] = useState([]);
    const [IdleCost, setIdleCost] = useState(billingDataProp?.IdleCost ? billingDataProp?.IdleCost : 0);
    const [refundAmount, setRefundAmount] = useState(0);
    const [refundFullAmount, setRefundFullAmount] = useState(false);
    const [refundMap, setRefundMap] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [particular, setParticular] = useState('');
   
    const [isNightChargeCreditRefund, setIsNightChargeCreditRefund] = useState(false);
    
 
    // refundedAmounts=[energy(with tax), unutilized fee, idle fee, cancellation fee] 
    
 const options = [
    (billingData !== null && refundAmounts[0] ===0 && ((totalCost - unUtilizedFee - taxCost) !==0) ) && {
      key: 'energy',
      label: 'Energy Cost',
      v: totalCost - unUtilizedFee - taxCost,
    },
    (billingData !== null && refundAmounts[4] ===0 && taxCost !== 0) && {
      key: 'tax',
      label: 'Tax Cost',
      v: taxCost,
    },
    (IdleCost > 0 && refundAmounts[2] ===0) && {
      key: 'idle',
      label: 'Idle Fee',
      v: IdleCost,
    },
    (unUtilizedFee > 0 && refundAmounts[1] ===0) && {
      key: 'unutilized',
      label: 'Unutilized Time Fee',
      v: unUtilizedFee,
    },
    (bookingStatus === 'Cancelled' && refundAmounts[3] ===0) && {
      key: 'cancellation',
      label: 'Cancellation Fee',
      v: estimateAmount,
    },
    (isNightCharging && bookingStatus !== 'Cancelled' && refundAmounts[5] ===0 && nightChargeEstimate > 0) && {
      key: 'nightChargeEstimate',
      label: 'Night Charging Fee',
      v: nightChargeEstimate,
    },
  ].filter(Boolean);

  useEffect(() => {
        console.log("Use effect called")
        // setRefundAmount(0);
    },
    [refundAmount,options])

//   console.log("OPtions", options)

    const handleRefundChange = (values) => {
        setRefundvalue(values);
        const total = values.reduce((acc, curr) => acc + Number(curr), 0);
        setRefundAmount(total);
        setRefundFullAmount(false);

        console.log("Refund Value in change function", total)
    };

    const submitRefund = async () =>{
        setIsLoading(true)
        let values ={};
        values.user = selUser._id;
        values.adminID = adminUser._id;
        values.adminType = adminUser.type;
        values.particular = particular;
        values.amount = refundAmount;
        values.type = "Credit"
        let res;

        try {
            let walletRes;
            if(refundAmount !== 0){
                walletRes = await BreathAPIs.updateWallet(values);
            }
            

            // console.log('refund object', refundAmount, refundMap, bookingId);

            if (walletRes?.status === 200 || (refundAmount === 0 && isNightChargeCreditRefund)) {
                 res = await BreathAPIs.makeBookingRefund(
                    bookingId,
                    refundAmount,
                    refundMap,
                    particular,
                    isNightChargeCreditRefund
                );

                // console.log('Refund Response', res);
                setBookingToView(res.data.booking);
            }
        } catch (err) {
            console.error("Refund failed:", err);
        } finally {
            // Clear state AFTER everything completes
            const newMap = { ...refundMap };
            Object.keys(newMap).forEach(key => delete newMap[key]);
            setRefundMap(newMap);
            setRefundAmount(0);
            setIsNightChargeCreditRefund(false);
            // setRefundMap({});
            setIsLoading(false);
            setRefundKeys([])
            setRefundvalue([])
        }
    };
    return (
    <div className={styles.refundBlock}>
        <button onClick={()=>setExpanded(!expanded)} className={styles['expand-button']}>
            {expanded ? <FiMinus /> : <FaPlus />}
            Make Refund
        </button>
        
        {
            expanded && (
                <div className={styles.refundForm} >
                        {/* Refund form goes here */}
                        <div className={styles['refund-header-container']}>
                        <p className={styles['refund-heading']}>Refund Form</p>
                            {isRefunded && <p className={styles['refund-subheading']}>Total Refunded:
                                <span className={styles['refunded-amount']}>
                                    ${(refundAmounts[0] + refundAmounts[1] + refundAmounts[2] + refundAmounts[3] + refundAmounts[4] + (refundAmount.length == 6 ? refundAmounts[5] : 0)).toFixed(2)}
                                </span></p>}
                        </div>
                        {/* {console.log("Refund amounts condition",refundAmounts[0], refundAmounts[1] , refundAmounts[2] ,refundAmounts[3] )} */}
                        {
                        (
                            (billingData !== null && refundAmounts[0] ===0 && ((totalCost - unUtilizedFee - taxCost) !==0)) ||
                            (unUtilizedFee > 0 && refundAmounts[1] ===0 ) || 
                            (IdleCost > 0 && refundAmounts[2] ===0) || 
                            (bookingStatus === 'Cancelled' && refundAmounts[3] ===0) ||
                            (billingData !== null && refundAmounts[4] ===0 && taxCost !== 0) || 
                            (isNightCharging && refundAmounts[5] === 0 && nightChargeEstimate > 0)
                        ) 
                        
                        &&
                        <>
                        <div className={styles['refund-full-amount']}>
                            <span className={styles['refund-full-amount-span']}>Refund Full Amount</span>
                            <Switch
                                checked={refundFullAmount}
                                onChange={(checked) => {
                                    setRefundFullAmount(checked);
                                    if (checked) {
                                        let amount = 0;
                                        setRefundAmount(0)
                                        options.forEach(option => {
                                            amount += option.v;
                                            setRefundvalue(prev => [...prev, option.v]);
                                            setRefundKeys(prev => [...prev, option.key]);
                                            setRefundMap(prev => ({ ...prev, [option.key]: option.v }));
                                            setRefundAmount(amount);
                                        })
                                    } else {
                                        setRefundvalue([]);
                                        setRefundKeys([]);
                                        setRefundMap({});
                                        setRefundAmount(0);
                                    }
                                }}
                                className={styles['refund-switch-input']}
                            />
                        </div>
                        <div>
                            {
                                options.map(option => (
                                    
                                    <div className={styles['refund-input-container']} key={option.key}> 
                                    {console.log("options : " , option.key)}
                                        <Checkbox
                                            key={option.key}
                                            value={option.v}
                                            checked={option.key in refundMap}
                                            onChange={(e) => {
                                                let newValues = [...refundValue, option.v];
                                                let newKeys = [...refundKeys, option.key];
                                                if (e.target.checked) {
                                                    let refundMapCopy = { ...refundMap };
                                                    setRefundMap(prev => ({ ...prev, [option.key]: option.v }));
                                                    refundMapCopy[option.key] = option.v
                                                    newValues = Object.values(refundMapCopy);
                                                    newKeys = Object.keys(refundMapCopy);
                                                    handleRefundChange(newValues);
                                                    setRefundKeys(newKeys);
                                                } else {
                                                    let refundMapCopy = { ...refundMap };
                                                    delete refundMapCopy[option.key];
                                                    console.log("Refund map copy",refundMapCopy)
                                                    setRefundMap(refundMapCopy);
                                                    newValues = Object.values(refundMapCopy);
                                                    newKeys = Object.keys(refundMapCopy);
                                                    handleRefundChange(newValues);
                                                    setRefundKeys(newKeys);
                                                }
                                                // console.log("options.length",options, "newKeys.length",newKeys)
                                                if(options.length === newKeys.length){
                                                    setRefundFullAmount(true)
                                                }else{
                                                    setRefundFullAmount(false)
                                                }
                                            }}
                                            className={styles['refund-checkbox-input']}
                                        >
                                            {option.label}
                                        </Checkbox>
                                        
                                        <InputNumber
                                            value={refundMap[option.key] || 0}
                                            disabled={!(option.key in refundMap)}
                                            onChange={(value)=>{
                                                let refundMapCopy = { ...refundMap };
                                                refundMapCopy[option.key] = value;
                                                let newValues = Object.values(refundMapCopy)
                                                handleRefundChange(newValues);
                                                setRefundMap(refundMapCopy);
                                                
                                            }}
                                            className={styles['refund-number-input']}
                                        />
                                </div>
                            ))
                        }
                    
                    {/* <CheckboxGroup options={refundableOptions()}/> */}
                    </div>
                    {(isNightCharging && nightChargeEstimate === 0) && <div>
                        <span className={styles['refund-full-amount-span']}>Overnight Charge Credit Refund</span>
                        <Switch
                                checked={isNightChargeCreditRefund}
                                onChange={(checked) => {
                                    setIsNightChargeCreditRefund(checked);
                                    // if (checked) {
                                    //     let amount = 0;
                                    //     setRefundAmount(0)
                                    //     options.forEach(option => {
                                    //         amount += option.v;
                                    //         setRefundvalue(prev => [...prev, option.v]);
                                    //         setRefundKeys(prev => [...prev, option.key]);
                                    //         setRefundMap(prev => ({ ...prev, [option.key]: option.v }));
                                    //         setRefundAmount(amount);
                                    //     })
                                    // } else {
                                    //     setRefundvalue([]);
                                    //     setRefundKeys([]);
                                    //     setRefundMap({});
                                    //     setRefundAmount(0);
                                    // }
                                }}
                                className={styles['refund-switch-input']}
                            />
                    </div>}

                    {(nightChargeEstimate === -1) && <p> Overnight credit refunded. </p>}
                    

                    <div className={styles['particular-input-container']}>
                        <span>Particular: </span>
                        <Input placeholder='Enter Particular' onChange={e =>setParticular(e.target.value)}></Input>
                    </div>
                    {/* {console.log("Refund amount in ret",refundAmount,"Map in ret", refundMap)} */}
                    <div className={styles['total-amount-display']}>Amount to refund: <span className={styles['total-amount-span']}> ${refundAmount.toFixed(2)}</span></div>
                    {/* <InputNumber
                        value={refundAmount}
                        onChange={(value) => setRefundAmount(value)}
                    /> */}
                        <button onClick={() => submitRefund()} className={styles['refund-submit']} disabled={(isNightChargeCreditRefund ? !isNightChargeCreditRefund : refundAmount === 0 ) || isLoading }>
                            {
                                isLoading ?
                                    <>Processing  <Spin size="small" /></>
                                    :
                                    "Process Refund"
                            }
                        </button>
                        </>}
                    </div>
            )
        }
    </div>
  )
}

export default MakeRefund

// import React, { useState } from 'react';
// import { Checkbox, Divider } from 'antd';
// const CheckboxGroup = Checkbox.Group;
// const plainOptions = ['Apple', 'Pear', 'Orange'];
// const defaultCheckedList = ['Apple', 'Orange'];
// const App = () => {
//   const [checkedList, setCheckedList] = useState(defaultCheckedList);
//   const checkAll = plainOptions.length === checkedList.length;
//   const indeterminate = checkedList.length > 0 && checkedList.length < plainOptions.length;
//   const onChange = list => {
//     setCheckedList(list);
//   };
//   const onCheckAllChange = e => {
//     setCheckedList(e.target.checked ? plainOptions : []);
//   };
//   return (
//     <>
//       <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
//         Check all
//       </Checkbox>
//       <Divider />
//       <CheckboxGroup options={plainOptions} value={checkedList} onChange={onChange} />
//     </>
//   );
// };
// export default App;

{/* <Select
                    style={{ width: "100%" }} 
                    placeholder="Select Refund Type"
                    mode='multiple'
                    onChange={(value) => handleRefundChange(value)}
                    value={refundValue}
                    disabled={refundFullAmount}
                    >
                            {
                                billingData !== null &&
                                <option value={totalCost - unUtilizedFee}>
                                    Energy Cost(Tax included)
                                </option>
                            }
                            {
                                IdleCost > 0 &&
                                <option value={IdleCost}>
                                    Idle Fee
                                </option>
                            }
                            {
                                billingData !== null &&
                                <option value={unUtilizedFee}>
                                    Unutilized Fee
                                </option>
                            }
                            {
                                bookingStatus === 'Cancelled' &&
                                <option value={estimateAmount}>
                                    Cancellation Fee
                                </option>
                            }
                    </Select> */}